import * as React from "react";
import { CaregiverAvailability, HRAvailabilityPlaceholderSettings } from "../../messages";
import { Checkbox } from "@blueprintjs/core";
import "./CaregiverAvailabilityScreen.css";

// tslint:disable-next-line
const ReactSlider = require("react-slider");

export interface CaregiverAvailabilityScreenProps {
    onBlur: (dayAvailabilities: CaregiverAvailability) => void;
    initialCaregiverAvailability: CaregiverAvailability;
    settings: HRAvailabilityPlaceholderSettings | null;
}

export interface CaregiverAvailabilityScreenState {
    caregiverAvailability: CaregiverAvailability;
}

export class CaregiverAvailabilityScreen extends React.Component<CaregiverAvailabilityScreenProps, CaregiverAvailabilityScreenState> {
    constructor(props: CaregiverAvailabilityScreenProps) {
        super(props);

        this.state = {
            caregiverAvailability: props.initialCaregiverAvailability
        };
    }

    handleDayTimesChange(value: number[], changedDay: number) {
        this.setState(prevState => ({
            caregiverAvailability: {
                maxDistance: prevState.caregiverAvailability.maxDistance,
                minDuration: prevState.caregiverAvailability.minDuration,
                maxDuration: prevState.caregiverAvailability.maxDuration,
                dayAvailabilities: prevState.caregiverAvailability.dayAvailabilities.map((dayAvailability) => {
                    if (changedDay === dayAvailability.day) {
                        return {
                            day: dayAvailability.day,
                            startHour: value[0],
                            endHour: value[1],
                            busyAllDay: dayAvailability.busyAllDay
                        };
                    }
                    return dayAvailability;
                })
            }
        }));
    }

    handleBusyAllDayChange(busyAllDay: boolean, changedDay: number) {
        this.setState(prevState => ({
            caregiverAvailability: {
                maxDistance: prevState.caregiverAvailability.maxDistance,
                minDuration: prevState.caregiverAvailability.minDuration,
                maxDuration: prevState.caregiverAvailability.maxDuration,
                dayAvailabilities: prevState.caregiverAvailability.dayAvailabilities.map((dayAvailability) => {
                    if (changedDay === dayAvailability.day) {
                        return {
                            day: dayAvailability.day,
                            startHour: dayAvailability.startHour,
                            endHour: dayAvailability.endHour,
                            busyAllDay: busyAllDay
                        };
                    }

                    return dayAvailability;
                })
            }
        }));

        this.props.onBlur(this.state.caregiverAvailability);
    }

    handleDistanceChange(distance: number) {
        this.setState(prevState => ({
            caregiverAvailability: {
                minDuration: prevState.caregiverAvailability.minDuration,
                maxDuration: prevState.caregiverAvailability.maxDuration,
                maxDistance: distance,
                dayAvailabilities: prevState.caregiverAvailability.dayAvailabilities
            }
        }));
    }

    handleDurationChange(duration: number[]) {
        this.setState(prevState => ({
            caregiverAvailability: {
                minDuration: duration[0],
                maxDuration: duration[1],
                maxDistance: prevState.caregiverAvailability.maxDistance,
                dayAvailabilities: prevState.caregiverAvailability.dayAvailabilities
            }
        }));
    }

    hoursToDisplayTime(hours: number): string {
        if (hours === 12) {
            return hours + "PM";
        } else if (hours === 0 || hours === 24) {
            hours = 12;
            return hours + "AM";
        } else if (hours > 12) {
            hours = hours - 12;
            return hours + "PM";
        } else {
            return hours + "AM";
        }
    }

    getDayDisplayNameFromIndex(index: number): string {
        const days = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ];

        return days[index];
    }

    renderDayAvailability(): JSX.Element {
        return (
            <div className={"AvailabilityScreen__card"}>
                <div className="AvailabilityScreen__cardHeader">
                    <div className={"AvailabilityScreen__cardHeaderIconAvailability"}/>
                    <div className="AvailabilityScreen__cardTitle">
                        Availability
                    </div>
                </div>

                {this.state.caregiverAvailability.dayAvailabilities.map((day, index) => {
                    return (
                        <div className="AvailabilityScreen__sliderContainer" key={day.day}>
                            <div className="AvailabilityScreen__sliderContainerTitle">
                                <span
                                    className={"AvailabilityScreen__sliderContainerBold"}
                                >
                                    {this.getDayDisplayNameFromIndex(index)},
                                </span>
                                {day.busyAllDay ? " not available" :
                                    (day.startHour === 0 && day.endHour === 24) ?
                                        <span>I'm available <span className="AvailabilityScreen__sliderContainerBold">all day</span></span> :
                                        <span>I'm available <span className="AvailabilityScreen__sliderContainerBold" >
                                            {this.hoursToDisplayTime(day.startHour)} - {this.hoursToDisplayTime(day.endHour)}
                                        </span></span>}
                            </div>
                            <ReactSlider
                                barClassName={"CaregiverAvailabilityScreen__bar"}
                                withBars={true}
                                disabled={day.busyAllDay}
                                className="AvailabilityScreen__slider"
                                max={24}
                                min={0}
                                minDistance={3}
                                value={[day.startHour, day.endHour]}
                                step={1}
                                onChange={(value: number[]) => this.handleDayTimesChange(value, index)}
                                key={index}
                                snapDragDisabled={true}
                                onAfterChange={() => this.props.onBlur(this.state.caregiverAvailability)}
                            >
                                <div className={"AvailabilityScreen__handleStart " + (day.busyAllDay ? "AvailabilityScreen__disabledHandle" : "")}>
                                    {this.hoursToDisplayTime(day.startHour)}
                                </div>
                                <div className={"AvailabilityScreen__handleEnd " + (day.busyAllDay ? "AvailabilityScreen__disabledHandle" : "")}>
                                    {this.hoursToDisplayTime(day.endHour)}
                                </div>
                            </ReactSlider>
                            <div
                                className="AvailabilityScreen__busyAllDayContainer"
                            >
                                <Checkbox
                                    label="busy All Day"
                                    defaultChecked={day.busyAllDay}
                                    onClick={() => this.handleBusyAllDayChange(!day.busyAllDay, index)}
                                />
                            </div>
                        </div>
                    );
                })
                }
            </div>);
    }

    renderDistanceAvailability() {
        return (
            <div className={"AvailabilityScreen__card"}>
                <div className="AvailabilityScreen__cardHeader">
                    <div className={"AvailabilityScreen__cardHeaderIconDistance"}/>
                    <div className="AvailabilityScreen__cardTitle">
                        Max travel
                        distance: {this.state.caregiverAvailability.maxDistance} {this.state.caregiverAvailability.maxDistance === 1 ? "mile" : "miles"}
                    </div>
                </div>
                <div className="AvailabilityScreen__sliderContainer">
                    <ReactSlider
                        barClassName={"CaregiverAvailabilityScreen__singleBar"}
                        withBars={true}
                        className="AvailabilityScreen__slider"
                        max={30}
                        min={1}
                        value={this.state.caregiverAvailability.maxDistance}
                        step={1}
                        snapDragDisabled={true}
                        onChange={(value: number) => this.handleDistanceChange(value)}
                        onAfterChange={() => this.props.onBlur(this.state.caregiverAvailability)}
                    >
                        <div className="AvailabilityScreen__handleStart">{this.state.caregiverAvailability.maxDistance}
                            Mi
                        </div>
                    </ReactSlider>
                </div>
            </div>
        );
    }

    renderHoursAvailability() {
        return (
            <div className={"AvailabilityScreen__card"}>
                <div className="AvailabilityScreen__cardHeader">
                    <div className={"AvailabilityScreen__cardHeaderIconTime"}/>
                    <div className="AvailabilityScreen__cardTitle">
                        Hours per visit
                        {this.state.caregiverAvailability.minDuration === 0 && this.state.caregiverAvailability.maxDuration === 24 ?
                            <div>Visit lasting: any duration</div>
                            :
                            <div>
                                Visit lasting:
                                between {this.state.caregiverAvailability.minDuration} and {this.state.caregiverAvailability.maxDuration} Hours
                            </div>
                        }
                    </div>
                </div>
                <div className="AvailabilityScreen__sliderContainer">
                    <ReactSlider
                        barClassName={"CaregiverAvailabilityScreen__bar"}
                        withBars={true}
                        className="AvailabilityScreen__slider"
                        max={24}
                        min={1}
                        minDistance={3}
                        value={[this.state.caregiverAvailability.minDuration, this.state.caregiverAvailability.maxDuration]}
                        step={1}
                        snapDragDisabled={true}
                        onChange={(value: number[]) => this.handleDurationChange(value)}
                        onAfterChange={() => this.props.onBlur(this.state.caregiverAvailability)}
                    >
                        <div className="AvailabilityScreen__handleStart">
                            {this.state.caregiverAvailability.minDuration} {this.state.caregiverAvailability.minDuration === 1 ? "Hr" : "Hrs"}
                        </div>
                        <div className="AvailabilityScreen__handleEnd">
                            {this.state.caregiverAvailability.maxDuration}Hrs
                        </div>
                    </ReactSlider>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div>
                <div>
                    {this.renderDayAvailability()}
                    {this.props.settings === null || this.props.settings.showDistanceQuestion ? this.renderDistanceAvailability() : null}
                    {this.props.settings === null || this.props.settings.showHoursQuestion ? this.renderHoursAvailability() : null}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/placeholders/CaregiverAvailabillityScreen.tsx